module.exports = __webpack_public_path__ + "static/media/m42.054ccd1c.webp";